import "./Slide.css";
import LinkButton from "./LinkButton";
import { ReactComponent as LinkArrow } from "./static/icons/LinkArrow.svg";
import { ReactComponent as PageNumberLine } from "./static/icons/PageNumberLine.svg";

function goToPage(url) {
  window.open(url, "_self");
}

function Slide({
  children,
  backgroundImage,
  number,
  url,
  showLinkButton = true,
  showPageNumber = true,
}) {
  return (
    <div
      id={number}
      className="Slide"
      style={{ background: `url(${backgroundImage})` }}
    >
      {showPageNumber && (
        <div className="PageCount">
          0{number + 1} <PageNumberLine /> 05
        </div>
      )}{" "}
      {children}
      {showLinkButton && (
        <LinkButton
          classes="linkButtonMargin"
          text="SEE THE CASE"
          icon={<LinkArrow />}
          onClick={() => goToPage(url)}
        ></LinkButton>
      )}
    </div>
  );
}

export default Slide;
export { goToPage };
